import type { HTMLAttributes } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export type CardVariant = 'default' | 'raised' | 'operational' | 'flat'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant
  padding?: 'none' | 'compact' | 'comfortable'
}

export function Card({ className, variant = 'default', padding = 'comfortable', ...props }: CardProps) {
  return (
    <div
      className={mergeClassNames('ds-card', `ds-card--${variant}`, `ds-card--padding-${padding}`, className)}
      {...props}
    />
  )
}
